import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'filename',
    title: 'File Name',
    show: true,
    width: 320,
    valuesExport: ['filename']
  },
  {
    isSortable: true,
    field: 'action',
    title: 'Action',
    show: true,
    width: 104,
    valuesExport: ['action']
  },
  {
    isSortable: true,
    field: 'companyName',
    title: 'Customer name',
    show: true,
    width: 312,
    valuesExport: ['companyName', 'customerId', 'country']
  },
  {
    isSortable: true,
    field: 'platform',
    title: 'Platform',
    show: true,
    width: 160,
    valuesExport: ['platform']
  },
  {
    isSortable: true,
    field: 'newVersion',
    title: 'Current Version',
    show: true,
    width: 176,
    valuesExport: ['newVersion']
  },
  {
    isSortable: true,
    field: 'oldVersion',
    title: 'Previous version',
    show: true,
    width: 176,
    valuesExport: ['oldVersion']
  },
  {
    isSortable: true,
    field: 'updatedByName',
    title: 'Updated By',
    show: true,
    width: 280,
    valuesExport: ['updatedByName', 'updatedByEmail']
  },
  {
    isSortable: true,
    field: '_created_at',
    title: 'Created At',
    show: true,
    width: 136,
    valuesExport: ['_created_at']
  },
  {
    isSortable: true,
    field: 'status',
    title: 'Success/Error',
    show: true,
    width: 162,
    valuesExport: ['status']
  }
];

export const defaultFilters = {
  search: '',
  action: [],
  platform: [],
  oldVersion: [],
  newVersion: [],
  updatedByName: [],
  status: [],
  _created_at: { startDate: null, endDate: null },
  isTestTenant: ''
};

export const defaultNavigation = {
  fieldName: '_created_at',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};

export const exportConfigVersionsActivityLog = {
  exportUrl: '/cs/agents/logs/list/export',
  exportName: 'VersionsActivityLog',
  exportFormat: 'zip'
};
